/**
 * Cart line-item media helpers for the custom-photo poster feature.
 *
 * Loaded before theme.js in layout/theme.liquid so the cart drawer's view-model builder
 * can use them. Kept in their own file rather than inline in theme.js so the logic is
 * unit-testable (see custom-photo-cart.test.html) and the shared file's diff stays tiny.
 *
 * Both functions are no-ops for ordinary line items: customPhotoLineMedia returns null so
 * the caller keeps its existing behaviour, and stripCustomPhotoProperty only ever removes
 * the `Image` key.
 */
(function () {
  window.theme = window.theme || {};

  // Same CDN base the frame swatches already use in snippets/variant-button.liquid.
  var SWATCH_BASE = 'https://cdn.shopify.com/s/files/1/0521/3831/1842/t/2/assets/';

  /**
   * Thumbnail URL for a /cart.js line item, or null to fall back to default handling.
   *  - Custom-photo lines carry an `Image` property: the customer's uploaded JPEG.
   *  - Frame upsell products usually have no product image; derive their swatch from
   *    the frame-paper- / frame-canvas- handle prefix.
   */
  theme.customPhotoLineMedia = function (item) {
    if (!item) return null;

    var props = item.properties;
    if (props && props.Image) return props.Image;

    var handle = item.handle || (item.product && item.product.handle) || '';
    // Prefix match, not `indexOf(...) !== -1`, so an ordinary product whose handle merely
    // contains "frame" (e.g. "poster-in-a-frame") is not mistaken for a frame product.
    if (handle.indexOf('frame-paper-') === 0 || handle.indexOf('frame-canvas-') === 0) {
      var color = handle.replace(/^frame-(?:paper|canvas)-/, '');
      return SWATCH_BASE + 'ramme-i-' + color + '_50x.png';
    }

    return null;
  };

  /**
   * Remove the `Image` property so the uploaded file's name isn't printed as text
   * beneath the thumbnail it already renders as. It stays on the order for the operator.
   * Mutates in place, matching how the caller already strips underscore-prefixed keys.
   */
  theme.stripCustomPhotoProperty = function (properties) {
    if (properties && Object.prototype.hasOwnProperty.call(properties, 'Image')) {
      delete properties.Image;
    }
    return properties;
  };
})();
